var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { Link } from 'react-router-dom';
import "../styles/Arts.css";
var FilesTodownload = function (_a) {
    var type = _a.type, href = _a.href;
    return (_jsxs("div", { children: [type === "download" &&
                _jsx(Link, __assign({ className: "button-download-art", to: href, target: "_blank", download: true }, { children: _jsx("p", { children: "Abrir anexo" }) })), type === "button" &&
                _jsx(Link, __assign({ className: "button-download-art", to: href, target: "_blank" }, { children: _jsx("p", { children: "Abrir anexo" }) })), type === "icon" &&
                _jsx("button", __assign({ id: "button-download-error", "aria-label": "Baixar arquivo" }, { children: _jsx(UploadFileIcon, {}) }))] }));
};
export default FilesTodownload;
